import { BvApolloClient, Store as MainStore } from '@dinosband/bv-main-client'
import { PubSub } from '@dinosband/dbi-utils'
import { BvDataCenter } from '..'

import { ChatRoomQueryFilters } from '../data-center/filter'

export interface BvDataCenterContext {
  mainStore: MainStore
  dataCenter: BvDataCenter
  messengerClient: BvApolloClient
  queryFilters: ChatRoomQueryFilters
  limit?: { chatRoomIds: number[] }
  pubsub: PubSub
}

export class BvDataCenterContext implements BvDataCenterContext {
  mainStore!: MainStore
  dataCenter!: BvDataCenter
  messengerClient: BvApolloClient
  pubsub: PubSub

  constructor (messengerClient: BvApolloClient) {
    this.messengerClient = messengerClient
    this.pubsub = new PubSub()
  }

}

